export default __webpack_public_path__ + "static/media/Filled.29a44281.svg";